import React from "react";
import { RadioButton } from "components/primaryComponents";
import "./BoxedRadioInput.scss";

export const BoxedRadioInput = ({
  children,
  name,
  value,
  id,
  isChecked,
  setRadioValue,
  isDisabled = false,
}) => {
  return (
    <label
      className={`boxed-radio ${isChecked && "active"} ${
        isDisabled && "disabled"
      }`}
    >
      <RadioButton
        name={name}
        value={value}
        id={id}
        checked={isChecked}
        isDisabled={isDisabled}
        setRadioValue={setRadioValue}
      />
      <span>{children}</span>
    </label>
  );
};
